module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("12P1a"))).then(() => parcelRequire('9Lwss'));